export default "__VITE_ASSET__Bg5J9UMW__"